/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgeUnitoBasecampDevIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-basecamp-dev" */ './utils').then(
			(m) => m.ForgeUnitoBasecampDevIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-basecamp-dev/icon' },
);

const LazyForgeUnitoBasecampDevSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-unito-basecamp-dev-search-result" */ './utils').then(
			(m) => m.ForgeUnitoBasecampDevSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-unito-basecamp-dev/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgeUnitoBasecampDevIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoBasecampDevIconComponent />
	</Suspense>
);

export const ForgeUnitoBasecampDevSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgeUnitoBasecampDevSearchResultIconComponent />
	</Suspense>
);
